import React, {Fragment, useState} from "react";
import AttachFile from "@mui/icons-material/AttachFile";
import {IconButton, Menu, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import AttachmentList from "./AttachmentList";

const PackageAttachments = ({packageId, attachments}) => {
  const {t} = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    (attachments || []).length > 0 && (
      <Fragment>
        <Tooltip title={t("components.packageAttachments.button.title")}>
          <IconButton
            id="package-attachments-button"
            className="package-attachments__btn"
            onClick={e => setAnchorEl(e.currentTarget)}
          >
            <AttachFile />
          </IconButton>
        </Tooltip>
        <Menu
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorEl={anchorEl}
          keepMounted
          className="package-attachments__menu"
          sx={{maxWidth: "50%"}}
        >
          <AttachmentList packageId={packageId} attachments={attachments} />
        </Menu>
      </Fragment>
    )
  );
};

export default PackageAttachments;
